// extracted by mini-css-extract-plugin
export default {"content":"CaseDocumentSearchPageAgreement_content__Cq5NN","back":"CaseDocumentSearchPageAgreement_back__kXrAQ"};